import React, { memo } from 'react';

/**
 *
 */
const CtaCard = ({ logo = '', title = '', buttonText = 'Visit', duration, onBtnClick }) => {
  const onCtaBtnClick = () => {
    if (onBtnClick) {
      onBtnClick();
    }
  };
  return (
    <>
      {(title || duration) && (
        <div className="clr_player__leftCTA cursorPointer" onClick={onCtaBtnClick}>
          <div className="clr_player__CTACard">
            {logo && (
              <div className="clr_player__CTACard--logo">
                <img src={logo} alt={title} />
              </div>
            )}
            <div className="clr_player__CTACard--content">
              {title && <h4 className="clr_player__CTACard--ttl">{title}</h4>}
              <button className="clr_player__CTACard--button">{buttonText}</button>
            </div>
          </div>
          {duration && <span className="clr_player_left_adCount">ad 1 of 1 | {duration}</span>}
        </div>
      )}
    </>
  );
};

export default CtaCard; 
